import { signal } from '@angular/core';
import { RuntimeProfile } from './runtime-profile';
import { State } from './state';

export const defaultLocationKey = signal<string>('defaultLocation');

export const defaultSettings = {
    runtimeProfile: RuntimeProfile.Daily,
    startTimeSecurityTime: 5,
    endTimeSecurityTime: 5,
    systemVolume: 8,
    pricePerKWh: 0.2,
    minOperatingPressure: 6,
    safetyZone: 0.3,
};

export const RuntimeProfiles = [
    { label: 'pressureMonitoring.settings.runtimeProfiles.daily', value: RuntimeProfile.Daily },
    { label: 'pressureMonitoring.settings.runtimeProfiles.weekly', value: RuntimeProfile.Weekly },
    { label: 'pressureMonitoring.settings.runtimeProfiles.fullTime', value: RuntimeProfile.FullTime },
];

export const States = [
    { label: 'pressureMonitoring.settings.states.badenWuerttemberg', value: State.BadenWuerttemberg },
    { label: 'pressureMonitoring.settings.states.bayern', value: State.Bayern },
    { label: 'pressureMonitoring.settings.states.berlin', value: State.Berlin },
    { label: 'pressureMonitoring.settings.states.brandenburg', value: State.Brandenburg },
    { label: 'pressureMonitoring.settings.states.bremen', value: State.Bremen },
    { label: 'pressureMonitoring.settings.states.hamburg', value: State.Hamburg },
    { label: 'pressureMonitoring.settings.states.hessen', value: State.Hessen },
    { label: 'pressureMonitoring.settings.states.mecklenburgVorpommern', value: State.MecklenburgVorpommern },
    { label: 'pressureMonitoring.settings.states.niedersachsen', value: State.Niedersachsen },
    { label: 'pressureMonitoring.settings.states.nordrheinWestfalen', value: State.NordrheinWestfalen },
    { label: 'pressureMonitoring.settings.states.rheinlandPfalz', value: State.RheinlandPfalz },
    { label: 'pressureMonitoring.settings.states.saarland', value: State.Saarland },
    { label: 'pressureMonitoring.settings.states.sachsen', value: State.Sachsen },
    { label: 'pressureMonitoring.settings.states.sachsenAnhalt', value: State.SachsenAnhalt },
    { label: 'pressureMonitoring.settings.states.schleswigHolstein', value: State.SchleswigHolstein },
    { label: 'pressureMonitoring.settings.states.thueringen', value: State.Thueringen },
];
